import React from 'react'
import classes from './SpinLoader.module.css'
const SpinLoader = () =>  <div className={classes.spinLoader}> <span className={classes.loader}/></div>
export default SpinLoader